<template>
  <div v-if="can(action, globalHashid)" class="container d-flex justify-content-between">
    <slot />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AbilityWrapper",
  props: {
    globalHashid: {
      required: true,
      type: String,
    },
    action: {
      required: true,
      type: String,
    },
  },
  computed: {
    ...mapGetters({
      can: "currentUser/can",
    }),
  },
  created() {
    this.checkAbility({ action: this.action, globalHashid: this.globalHashid });
  },
  methods: {
    ...mapActions({
      checkAbility: "currentUser/checkAbility",
    }),
  },
};
</script>
